import {
  LOGIN_PATH,
  ONBOARDING_QUERY_PARAM,
  REDIRECT_QUERY_PARAM,
  normalizeOnboardingQueryValue,
  normalizeRedirectTarget,
  type OnboardingQueryValue,
} from '../hooks/admin/redirectTarget'
import { getAdminHomePath } from '../hooks/admin/adminPath'
import { isPublicAdminPath } from '../hooks/admin/adminRouteGuard'

const FORGOT_PASSWORD_PATH_REGEX = /^\/forgot-password\/?$/
const RESET_PASSWORD_PATH_REGEX = /^\/reset-password\/?$/

export type SetupEntryIntent = 'welcome' | 'setup' | 'login'

export const resolveSetupEntryIntentFromLocation = ({
  pathname,
  search,
}: {
  pathname: string
  search: string
}): SetupEntryIntent => {
  if (FORGOT_PASSWORD_PATH_REGEX.test(pathname) || RESET_PASSWORD_PATH_REGEX.test(pathname)) {
    return 'login'
  }

  const params = new URLSearchParams(search)
  const step = params.get('step')
  if (typeof step === 'string' && step.trim().length > 0) {
    return 'setup'
  }

  const onboarding = normalizeOnboardingQueryValue(params.get(ONBOARDING_QUERY_PARAM))
  if (onboarding === 'setup') return 'setup'
  if (onboarding === 'login') return 'login'
  return 'welcome'
}

export const buildSetupEntryUrl = ({
  intent,
  pathname,
  search,
  origin,
}: {
  intent: OnboardingQueryValue
  pathname: string
  search: string
  origin: string
}): string => {
  const currentParams = new URLSearchParams(search)
  const params = new URLSearchParams()
  params.set(ONBOARDING_QUERY_PARAM, intent)

  if (intent === 'login') {
    const redirect = normalizeRedirectTarget(currentParams.get(REDIRECT_QUERY_PARAM), origin)
    if (redirect) {
      params.set(REDIRECT_QUERY_PARAM, redirect)
    }
    return `${LOGIN_PATH}?${params.toString()}`
  }

  const targetPath = pathname === '/login' || isPublicAdminPath(pathname) ? getAdminHomePath() : pathname
  return `${targetPath}?${params.toString()}`
}
